/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Schedule_Summary_Hourly_On_The_HourInputs */



/**
* | output |
* | --- |
* | "Every hour, on the hour" |
*
* @param {Agent_Schedule_Summary_Hourly_On_The_HourInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_schedule_summary_hourly_on_the_hour = /** @type {((inputs?: Agent_Schedule_Summary_Hourly_On_The_HourInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Schedule_Summary_Hourly_On_The_HourInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Stündlich zur vollen Stunde")
	return /** @type {LocalizedString} */ ("Every hour, on the hour")
});